import {
  doc,
  setDoc,
  getDoc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../config/firebase";

/**
 * Save or update user wallet address
 * @param {string} address - Wallet address
 * @param {object} additionalData - Additional user data
 * @returns {Promise<object>} User document data
 */
export const saveUserWallet = async (address, additionalData = {}) => {
  try {
    if (!address) {
      throw new Error("Wallet address is required");
    }

    // Normalize address to lowercase
    const normalizedAddress = address.toLowerCase();

    // Get existing user document
    const userRef = doc(db, "users", normalizedAddress);
    const userDoc = await getDoc(userRef);

    const now = serverTimestamp();
    const userData = {
      address: normalizedAddress,
      updatedAt: now,
      ...additionalData,
    };

    if (userDoc.exists()) {
      // Update existing user
      await updateDoc(userRef, userData);
      return { id: normalizedAddress, ...userDoc.data(), ...userData };
    } else {
      // Create new user
      await setDoc(userRef, {
        ...userData,
        createdAt: now,
        firstConnectedAt: now,
      });
      return { id: normalizedAddress, ...userData };
    }
  } catch (error) {
    console.error("Error saving user wallet:", error);
    throw error;
  }
};

/**
 * Get user data by wallet address
 * @param {string} address - Wallet address
 * @returns {Promise<object|null>} User document or null if not found
 */
export const getUserByAddress = async (address) => {
  try {
    if (!address) {
      return null;
    }

    const normalizedAddress = address.toLowerCase();
    const userRef = doc(db, "users", normalizedAddress);
    const userDoc = await getDoc(userRef);

    if (userDoc.exists()) {
      return { id: userDoc.id, ...userDoc.data() };
    }

    return null;
  } catch (error) {
    console.error("Error getting user by address:", error);
    throw error;
  }
};

